// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.left-Create-Order {
  width: 100%;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  cursor: auto;
  gap: 0.29vw;
}
 
.middle-Create-Order {
  /* border: .05vw solid rgb(207, 255, 192) !important; */
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  /* padding: 0px !important; */
  /* padding-right: 15px !important; */
  /* gap: 20px; */
}
 
.long-content-new-Create-Order {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 0.4vw;
}
 
.long-content-new-Create-Order-0 {
  display: flex;
  align-items: center;
  justify-items: center;
  column-gap: 0.5vw;
}
 
.long-content-typo {
  display: flex;
  align-items: center;
  font-family: "karla" !important;
  font-size: 0.7vw !important;
  /* font-size: 12px !important; */
 
  font-weight: 400 !important;
 
  white-space: nowrap;
  /* line-height: 1.2vw !important ; */
}
 
.long-content-typo-0 {
  display: flex;
  align-items: center;
  font-family: karla !important;
  font-size: 0.7vw !important;
  /* font-size: 14px !important; */
 
  font-weight: 500;
 
  /* line-height: 1.5vw !important; */
}
 
.long-card-image-Create-Order {
  height: 9vw !important;
  width: 9vw !important;
  border-radius: 0.2vw !important;
  cursor: pointer !important;
}
 
.card-content-Create-Order {
  border-radius: 0.25vw;
  border: 0.25vw solid #cccccc !important;
  display: flex;
  gap: 0.5vw;
  padding: 0.5vw;
}
 
/*
.filter-select {
  border:0.5px solid #262626;
  background-color: black;
  border-radius: 5px;
  display: flex;  
  width: fit-content;
}
 
.filter-select label {
  padding:0px 3.6px ;
  height: 20px;
  margin-top: -3px;
 
}
 
.filter-select select {
  background-color: transparent;
  color:white;
  border:none;
  border-left: 0.5px solid #262626;
  font-family: "Karla";
  height: 20px;
  font-size: 10px;
  option {
    background-color: #262626;
  }
} */
.filter-select {
  border: 0.05vw solid #262626;
  background-color: black;
  border-radius: 0.3vw;
  display: flex;
  align-items: center;
  width: -moz-fit-content;
  width: fit-content;
  height: 1.6vw;
  position: relative;
}
 
.filter-select label {
  padding: 0 0.3vw;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
 
.filter-select select {
  background-color: transparent;
  color: white;
  border: none;
  border-left: 0.05vw solid #262626;
  font-family: "Karla";
  font-size: 0.6vw;
  height: 100%;
  padding: 0 1.2vw 0 0.3vw;
  appearance: none;
}
 
.filter-select select option {
  background-color: #262626;
  color: white;
}
 
.filter-select .down-label {
  /* margin-top: 0.05vw; */
  position: absolute;
  right: 0.4vw;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 0.5vw;
  color: white;
  transition: transform 0.3s ease;
}
 
.color-select {
  cursor: pointer;
}
 
.custom-select-value {
   display: inline-block;
  min-width: 3.7vw;        
  max-width: 1vw;  
   margin: 0px;
  display: flex;
  align-items: center;
  padding: 0 1.2vw 0 0.3vw;
  height: 100%;
  font-family: "Karla";
  font-size: 0.6vw;
}
 
.custom-options {
  position: absolute;
  top: 100%;
  left: 20px;
  width: 4.2vw;
  background: white;
  list-style: none;
  padding: 0;
  margin: 0;
  border-radius: 0.3vw;
  overflow: hidden;
  z-index: 100;
  font-size: 13px;
  font-family: Karla,sans-serif;
  font-weight: 500;
}
 
.custom-options li {
   margin: 4px;
  padding: 0.4vw;
  color: black;
  cursor: pointer;
}
 
.custom-options li:hover {
  /* margin: 5px; */
   color: #fff;       
  background: #000;
  border-radius: 8px;
  background: #444444;
}
 
.filter-select select::-webkit-scrollbar {
  display: none;
}
 
.custom-input::placeholder {
  color: #333333;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/LongCard/longCard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;EAClC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uDAAuD;EACvD,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;EAClC,sCAAsC;EACtC,6BAA6B;EAC7B,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,gCAAgC;;EAEhC,2BAA2B;;EAE3B,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,gCAAgC;;EAEhC,gBAAgB;;EAEhB,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,uCAAuC;EACvC,aAAa;EACb,UAAU;EACV,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2BG;AACH;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,iCAAiC;EACjC,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;GACG,qBAAqB;EACtB,gBAAgB;EAChB,cAAc;GACb,WAAW;EACZ,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;GACG,WAAW;EACZ,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;GAChB,WAAW;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".left-Create-Order {\n  width: 100%;\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: flex-start !important;\n  cursor: auto;\n  gap: 0.29vw;\n}\n \n.middle-Create-Order {\n  /* border: .05vw solid rgb(207, 255, 192) !important; */\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: flex-start !important;\n  justify-content: flex-start !important;\n  /* padding: 0px !important; */\n  /* padding-right: 15px !important; */\n  /* gap: 20px; */\n}\n \n.long-content-new-Create-Order {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  column-gap: 0.4vw;\n}\n \n.long-content-new-Create-Order-0 {\n  display: flex;\n  align-items: center;\n  justify-items: center;\n  column-gap: 0.5vw;\n}\n \n.long-content-typo {\n  display: flex;\n  align-items: center;\n  font-family: \"karla\" !important;\n  font-size: 0.7vw !important;\n  /* font-size: 12px !important; */\n \n  font-weight: 400 !important;\n \n  white-space: nowrap;\n  /* line-height: 1.2vw !important ; */\n}\n \n.long-content-typo-0 {\n  display: flex;\n  align-items: center;\n  font-family: karla !important;\n  font-size: 0.7vw !important;\n  /* font-size: 14px !important; */\n \n  font-weight: 500;\n \n  /* line-height: 1.5vw !important; */\n}\n \n.long-card-image-Create-Order {\n  height: 9vw !important;\n  width: 9vw !important;\n  border-radius: 0.2vw !important;\n  cursor: pointer !important;\n}\n \n.card-content-Create-Order {\n  border-radius: 0.25vw;\n  border: 0.25vw solid #cccccc !important;\n  display: flex;\n  gap: 0.5vw;\n  padding: 0.5vw;\n}\n \n/*\n.filter-select {\n  border:0.5px solid #262626;\n  background-color: black;\n  border-radius: 5px;\n  display: flex;  \n  width: fit-content;\n}\n \n.filter-select label {\n  padding:0px 3.6px ;\n  height: 20px;\n  margin-top: -3px;\n \n}\n \n.filter-select select {\n  background-color: transparent;\n  color:white;\n  border:none;\n  border-left: 0.5px solid #262626;\n  font-family: \"Karla\";\n  height: 20px;\n  font-size: 10px;\n  option {\n    background-color: #262626;\n  }\n} */\n.filter-select {\n  border: 0.05vw solid #262626;\n  background-color: black;\n  border-radius: 0.3vw;\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  height: 1.6vw;\n  position: relative;\n}\n \n.filter-select label {\n  padding: 0 0.3vw;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n \n.filter-select select {\n  background-color: transparent;\n  color: white;\n  border: none;\n  border-left: 0.05vw solid #262626;\n  font-family: \"Karla\";\n  font-size: 0.6vw;\n  height: 100%;\n  padding: 0 1.2vw 0 0.3vw;\n  appearance: none;\n}\n \n.filter-select select option {\n  background-color: #262626;\n  color: white;\n}\n \n.filter-select .down-label {\n  /* margin-top: 0.05vw; */\n  position: absolute;\n  right: 0.4vw;\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  font-size: 0.5vw;\n  color: white;\n  transition: transform 0.3s ease;\n}\n \n.color-select {\n  cursor: pointer;\n}\n \n.custom-select-value {\n   display: inline-block;\n  min-width: 3.7vw;        \n  max-width: 1vw;  \n   margin: 0px;\n  display: flex;\n  align-items: center;\n  padding: 0 1.2vw 0 0.3vw;\n  height: 100%;\n  font-family: \"Karla\";\n  font-size: 0.6vw;\n}\n \n.custom-options {\n  position: absolute;\n  top: 100%;\n  left: 20px;\n  width: 4.2vw;\n  background: white;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  border-radius: 0.3vw;\n  overflow: hidden;\n  z-index: 100;\n  font-size: 13px;\n  font-family: Karla,sans-serif;\n  font-weight: 500;\n}\n \n.custom-options li {\n   margin: 4px;\n  padding: 0.4vw;\n  color: black;\n  cursor: pointer;\n}\n \n.custom-options li:hover {\n  /* margin: 5px; */\n   color: #fff;       \n  background: #000;\n  border-radius: 8px;\n  background: #444444;\n}\n \n.filter-select select::-webkit-scrollbar {\n  display: none;\n}\n \n.custom-input::placeholder {\n  color: #333333;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
